function openModalOnClick(e: Event) {
  const targetId = (e.target as HTMLElement).dataset.idRef!;
  const modal = document.getElementById(targetId);
  modal?.setAttribute("open", "true");
}

export default (): void => {
  const triggers = document.querySelectorAll(
    "button[data-id-ref],prism-button[data-id-ref]",
  );
  triggers.forEach((trigger) => {
    if (trigger.localName == "prism-button") {
      trigger.addEventListener("prismPress", openModalOnClick);
    } else {
      trigger.addEventListener("click", openModalOnClick);
    }
  });
};
